/**
 * WalterGO PDP Umami-Tracker
 * Spec: analytics/tracking-spec.md §3.3 (Phase 4 + Teil von 5+6)
 *
 * GALLERY:
 *   pdp.gallery.thumbnail_click   position, media_type
 *   pdp.gallery.video_play        position
 *   pdp.gallery.zoom_open         position
 *
 * BUYBOX:
 *   pdp.buybox.pure_cta_click       —
 *   pdp.buybox.bundle_cta_click     —
 *   pdp.buybox.fpt_button_visible   — (1x pro Pageview)
 *   pdp.buybox.fpt_button_click     —
 *   pdp.buybox.fpt_scan_complete    time_to_complete_ms
 *   pdp.buybox.quiz_button_enabled  time_since_pageview_ms
 *
 * SECTION-KLICKS (Phase 5+6, soweit über stabile Selektoren machbar):
 *   pdp.comparison.flexitec_link_click
 *   pdp.comparison.pure_cta_click
 *   pdp.comparison.set_cta_click
 *   pdp.expert.primary_cta_click
 *   pdp.expert.secondary_cta_click
 *   pdp.floating_bar.cta_click
 *
 * Section-VIEWS werden per Inline-Snippet in den jeweiligen Section-Files
 * gesetzt (data-pdp-section-view-Marker + wgTrackVisibility-Call).
 *
 * DSGVO-arm: keine Auswahl-Werte, keine Variant-IDs, keine Marken.
 */
(function () {
  'use strict';

  function track(name, data) {
    if (typeof window.wgTrack === 'function') {
      window.wgTrack(name, data);
    }
  }

  function initGallery() {
    document.addEventListener('click', function (e) {
      // Thumbnail-Klick
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (thumb) {
        var idx = parseInt(thumb.dataset.galleryThumb, 10);
        var mediaType = thumb.dataset.mediaType || 'image';
        track('pdp.gallery.thumbnail_click', {
          position: isNaN(idx) ? -1 : idx,
          media_type: mediaType
        });
      }

      // Zoom-Open (Image-Container Click → Expand)
      var imgContainer = e.target.closest('[data-gallery-image-container]');
      if (imgContainer && !e.target.closest('video') && !e.target.closest('[data-gallery-thumb]')) {
        var active = document.querySelector('[data-gallery-active-media]');
        var pos = -1;
        if (active && active.dataset.mediaIndex !== undefined) {
          pos = parseInt(active.dataset.mediaIndex, 10);
        }
        track('pdp.gallery.zoom_open', { position: isNaN(pos) ? -1 : pos });
      }
    });

    // Video-Play (delegation auf play-Event ist nur per capture möglich)
    document.addEventListener('play', function (e) {
      var v = e.target;
      if (!v || v.tagName !== 'VIDEO') return;
      if (!v.closest('[data-gallery-image-container]')) return;
      // Position aus aktivem Thumbnail ableiten
      var activeThumb = document.querySelector('[data-gallery-thumb].is-active');
      var pos = activeThumb ? parseInt(activeThumb.dataset.galleryThumb, 10) : -1;
      track('pdp.gallery.video_play', { position: isNaN(pos) ? -1 : pos });
    }, true);
  }

  function initBuybox() {
    // Pure / Bundle CTA (waltergo-variant-card mit data-option-type)
    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-variant-option][data-option-type]');
      if (!card) return;
      var type = card.dataset.optionType;
      if (type === 'single') track('pdp.buybox.pure_cta_click');
      else if (type === 'bundle') track('pdp.buybox.bundle_cta_click');
    });
  }

  function initFpt() {
    var pageviewAt = Date.now();

    // FPT-Button-Visible (1x via IntersectionObserver)
    var fptVisibleFired = false;
    function watchFptVisibility() {
      var btn = document.querySelector('[data-widget="fpt-button"]');
      if (!btn) return setTimeout(watchFptVisibility, 500); // FPT lädt asynchron
      if (fptVisibleFired) return;
      if (!('IntersectionObserver' in window)) {
        track('pdp.buybox.fpt_button_visible');
        fptVisibleFired = true;
        return;
      }
      var obs = new IntersectionObserver(function (entries) {
        if (fptVisibleFired) return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !fptVisibleFired) {
            fptVisibleFired = true;
            track('pdp.buybox.fpt_button_visible');
            obs.disconnect();
          }
        });
      }, { threshold: 0.3 });
      obs.observe(btn);
    }
    watchFptVisibility();

    // FPT-Button-Click (delegation, da Button asynchron eingehängt wird)
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-widget="fpt-button"]')) {
        track('pdp.buybox.fpt_button_click');
      }
    });

    // FPT-Scan-Complete: sessionStorage 'fpt-session' bekommt matchings
    var scanCompleteFired = false;
    var scanCompleteCheck = function () {
      if (scanCompleteFired) return;
      try {
        var s = JSON.parse(sessionStorage.getItem('fpt-session') || '{}');
        if (s && s.matchings && Object.keys(s.matchings).length > 0) {
          scanCompleteFired = true;
          track('pdp.buybox.fpt_scan_complete', {
            time_to_complete_ms: Date.now() - pageviewAt
          });
        }
      } catch (e) {}
    };
    // Initial check (falls schon Daten existieren, z.B. nach Navigation)
    scanCompleteCheck();
    // Periodisches Polling (sessionStorage hat kein change-Event)
    var pollIv = setInterval(function () {
      scanCompleteCheck();
      if (scanCompleteFired) clearInterval(pollIv);
    }, 800);
    // Sicherheits-Stop nach 10 Min
    setTimeout(function () { clearInterval(pollIv); }, 10 * 60 * 1000);

    // Quiz-Button-Enabled: #OpenQuestionnaire wird per disabled-Attribut gesteuert
    var quizEnabledFired = false;
    function watchQuizEnable() {
      var btn = document.getElementById('OpenQuestionnaire');
      if (!btn) return;
      if (!btn.disabled && !quizEnabledFired) {
        quizEnabledFired = true;
        track('pdp.buybox.quiz_button_enabled', {
          time_since_pageview_ms: Date.now() - pageviewAt
        });
        return;
      }
      var obs = new MutationObserver(function () {
        if (!btn.disabled && !quizEnabledFired) {
          quizEnabledFired = true;
          track('pdp.buybox.quiz_button_enabled', {
            time_since_pageview_ms: Date.now() - pageviewAt
          });
          obs.disconnect();
        }
      });
      obs.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    }
    watchQuizEnable();
  }

  function initSectionViews() {
    if (typeof window.wgTrackVisibility !== 'function') {
      return setTimeout(initSectionViews, 200);
    }
    // Jede PDP-Section markiert sich mit data-pdp-section="<name>".
    // Erzeugt pdp.<name>.view beim ersten Sichtbarwerden.
    document.querySelectorAll('[data-pdp-section]').forEach(function (el) {
      var name = el.dataset.pdpSection;
      if (!name) return;
      window.wgTrackVisibility(
        '[data-pdp-section="' + name + '"]',
        'pdp.' + name + '.view'
      );
    });
  }

  function initSectionClicks() {
    // FAQ-Toggle innerhalb [data-pdp-section="faq"]: <details>-Element toggle-Event
    document.querySelectorAll('[data-pdp-section="faq"] details').forEach(function (det, i) {
      det.addEventListener('toggle', function () {
        if (det.open) track('pdp.faq.toggle', { position: i });
      });
    });

    // Floating Action Bar — `.waltergo-fab` ist global (footer-group.json),
    // aber init() läuft nur auf Produktseiten (URL-Check oben). Daher feuern
    // diese Events nur im PDP-Kontext.
    document.addEventListener('click', function (e) {
      // Show: Toggle-Button geklickt, aria-expanded wechselt false → true
      var toggle = e.target.closest('.waltergo-fab [data-fab-toggle]');
      if (toggle && toggle.getAttribute('aria-expanded') === 'false') {
        track('pdp.floating_bar.show');
      }
      // CTA-Click: Click auf Action-Link in der ausgefahrenen Bar
      // (zusätzlich zu nav.cart.open/nav.search.open — verschiedene Abstraktion)
      var ctaLink = e.target.closest('.waltergo-fab .waltergo-fab__action');
      if (ctaLink) {
        track('pdp.floating_bar.cta_click');
      }
    });

    // Reviews Slider Scroll/Expand (Position via Scroll-Listener auf dem Slider)
    // Optional: nur grobe Track-Hits, keine kontinuierliche Daten-Flut
    var reviewSlider = document.querySelector(
      '[data-pdp-section="reviews"] .swiper, [data-pdp-section="reviews"] .scroller'
    );
    if (reviewSlider) {
      var lastReportedSlide = -1;
      reviewSlider.addEventListener('scroll', function () {
        var slideWidth = reviewSlider.firstElementChild
          ? reviewSlider.firstElementChild.getBoundingClientRect().width
          : reviewSlider.clientWidth / 2;
        var idx = Math.round(reviewSlider.scrollLeft / Math.max(slideWidth, 1));
        if (idx !== lastReportedSlide && idx >= 0) {
          lastReportedSlide = idx;
          // Debounce: nur alle 800ms feuern
          if (!reviewSlider.__wgScrollLock) {
            reviewSlider.__wgScrollLock = true;
            track('pdp.reviews.scroll', { position: idx });
            setTimeout(function () { reviewSlider.__wgScrollLock = false; }, 800);
          }
        }
      });
    }
  }

  function init() {
    // Nur auf Produktseiten initialisieren — schnelle Heuristik via URL
    if (!/\/products\//.test(window.location.pathname)) return;
    initGallery();
    initBuybox();
    initFpt();
    initSectionViews();
    initSectionClicks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
